module.exports = __webpack_public_path__ + "static/img/centerBack.ea04185f.png";